<template>
  <div class="lego-grid__indicator" v-if="isShowGridIndicator">
    <lego-grid-row>
      <lego-grid-column possession="1" v-for="i in 12" :key="i" />
    </lego-grid-row>
  </div>
</template>

<script>
const keyCode = {
  NUMBER_1: 49,
  NUMBER_2: 50,
  NUMBER_3: 51,
  NUMBER_4: 52,
};
export default {
  name: 'lego-grid-indicator',
  emits: ['toggle-guide'],
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShowGridIndicator: false,
    };
  },
  mounted() {
    if (process.env.NODE_ENV === 'dev') {
      document.addEventListener('keyup', this.onKeyUp);
      this.isShowGridIndicator = this.isShow;
    }
  },
  beforeUnmount() {
    if (process.env.NODE_ENV === 'dev') {
      document.removeEventListener('keyup', this.onKeyUp);
    }
  },
  methods: {
    onKeyUp(e) {
      if (e.altKey && e.keyCode === keyCode['NUMBER_1']) {
        this.isShowGridIndicator = !this.isShowGridIndicator;
      } else if (e.altKey && e.keyCode === keyCode['NUMBER_2']) {
        this.$emit('toggle-guide', 'row');
      } else if (e.altKey && e.keyCode === keyCode['NUMBER_3']) {
        this.$emit('toggle-guide', 'col');
      } else if (e.altKey && e.keyCode === keyCode['NUMBER_4']) {
        this.$emit('toggle-guide', 'box');
      }
    },
  },
};
</script>
